export class WebhookV1StandardPayloadGdsgOperationalArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gdsgOperationalNotification",
            "baseName": "gdsgOperationalNotification",
            "type": "WebhookV1GdsgOperationalNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadGdsgOperationalArguments.attributeTypeMap;
    }
    constructor() {
    }
}
